import React, { useState, useEffect } from "react";

import {
    colors,
    Container,
    Grid,
    Hidden,
    makeStyles,
    Paper,
    Slide,
    Typography,
} from "@material-ui/core";

import { useHistory } from "react-router-dom";
import {
    useStylesCAB,
    useStylesContainers,
    useStylesDPM,
    useStylesHed,
    useStylesSpDial,
    useStylesUiElemment,
} from "../../../../../St/comps/UseStyle";
import clsx from "clsx";
import { insh as inshst } from "../../../../../Context/InshSt";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { insh, sto, wsto } from "../../../../../Context/InshData";
import { useStylesBA } from "../../../../../St/comps/UseStyle";
import { getLS } from "../../../../../utils/useLS";

import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import ImportExcel from "../ImportExcel/ImportExcel";
import AddItems from "./addItems";
import axios from "axios";
import { uri } from "../../../../../help/Api";
const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        // paddingBottom: theme.spacing(3),
        // direction: "rtl",
        borderColor: colors.red[300],
        minHeight: "100%",
    },
    input: {
        display: "none",
    },
    imageLogo: {
        marginRight: 20,
        marginTop: 5,
        marginBottom: 10,
        textAlign: "center",
    },
    headerTitle: {
        backgroundColor: colors.red[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
        fontWeight: "bold",
        marginBottom: "0.5rem"
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: colors.blue[50],
        borderColor: colors.red[300],
    },

}));
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box >
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function TransitionUp(props) {
    return <Slide {...props} direction="up" />;
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
export default function ItemsMains(props) {
    const { AutoOptions, locat, isDialog, DialogClose } = props;
    const clasess = useStyles();
    const inshParm = { itake: 20, symple: "", groupSearch: null };
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const [excelData, setExcelData] = useState([]);


    // ==== b sd

    const his = useHistory();

    const classes = useStyles();
    const { t } = useTranslation(["forms", "translation"]);
    const getFormExcelData = async () => {
        const dataDown = excelData.map((sub, i) => {
            // alert("sub.الباركود");
          return {
            // barcode: sub.الباركود != null ? sub?.الباركود : sub.barcode,
            barcode: sub.الباركود == null ? sub.barcode:sub?.الباركود ,
            new_exchange_price: sub?.السعر !== null ? sub?.السعر : sub?.price == null ? 0 : sub?.price,
            val1: sub?.الكمية !== null ? sub?.الكمية : sub?.val == null ? 1 : sub?.val,
            expense: sub.الاعباء !== null ? sub?.الاعباء : sub?.expense == null ? 0 : sub?.expense,
            discount: sub?.الخصم !== null ? sub?.الخصم : sub?.discount == null ? 0 : sub?.discount,
          };
        });
        const tb = {
          wait: true,
          ExcelInv: true,
          parms: {
            // safe: valueSafes?.id,
            branch: sto.branchi,
            _Data: dataDown,
            // bol1: permiCuCo.CWVat,
            // sProTyInvPro: setting.PrTy_InPr,
          },
        };
    
        axios
          .post(uri + "GetD", tb)
          .then((res) => {

 
          })
          .catch((error) => {
            console.log(error);
          });
      };
    return (
        <div className={classes.root}>
            <Typography
                component="div"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
            >
                <Grid
                    container
                    justifyContent="center"
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                >
                    <Grid item lg={12} md={12} sm={12} xs={12} >
                        <div className={clasess.root} style={{ backgroundColor: "fff" }}>
                            <AppBar position="static" style={{ backgroundColor: "fff" }} >
                                <Tabs
                                    style={{ backgroundColor: colors.red[300] }}
                                    value={value}
                                    onChange={handleChange}
                                    aria-label="simple tabs example"
                                >
                                    <Tab style={{ fontWeight: "bold" }} label={t("translation:basic-product-data")}{...a11yProps(0)} />
                                    <Tab style={{ fontWeight: "bold" }} label="استيراد من اكسل"{...a11yProps(1)} />
                                </Tabs>
                            </AppBar>

                            <TabPanel value={value} index={0}>
                                {/* <b>تعريف المؤسسة</b> */}
                                <AddItems
                                    {...{
                                        AutoOptions,
                                        locat,
                                        isDialog,
                                        DialogClose,
                                        fromExcel: true,
                                    }}
                                />
                            </TabPanel>

                            <TabPanel value={value} index={1}>
                                <b>استيراد من اكسل</b>
                                <ImportExcel
                                    {...{
                                        isPurches: false,
                                        isStock: false,
                                        isItem: true,
                                        excelData,
                                        setExcelData
                                    }}
                                />

                            </TabPanel>
                        </div>
                    </Grid>
                </Grid>

            </Typography>
        </div>
    );
}
